import { useCallback, useEffect } from "react";
import { useMediaQueryBreakpoint } from "../useMediaQuery";
import { AuthFlows } from "../../constants/authSteps";
import { SCREENS } from "../../routes/screens";
import { useAtom, useSetAtom } from "jotai/index";
import { authModalEmailFieldAtom } from "../../atoms/auth/authModalEmailField";
import { useLocation, useNavigate } from "react-router-dom";
import { authRedirectPath } from "../../atoms/auth/authRedirectPath";
import { activeUserAtom } from "../../atoms/user/activeUserAtom";
import { useAtomValue } from "jotai";
import { authModalOpenAtom } from "../../atoms/location/authModalOpenAtom";
import { currentFlowAtom } from "../../atoms/location/currentFlowAtom";

const useAuthHandler = () => {
  const { isMobile } = useMediaQueryBreakpoint();
  const setFlow = useSetAtom(currentFlowAtom);
  const setAuthModalValue = useSetAtom(authModalOpenAtom);
  const setAuthModalEmailField = useSetAtom(authModalEmailFieldAtom);
  const [authRedirectValue, setAuthRedirect] = useAtom(authRedirectPath);
  const navigate = useNavigate();
  const location = useLocation();

  const user = useAtomValue(activeUserAtom);

  useEffect(() => {
    if (user && authRedirectValue) {
      setAuthModalValue(false);
      setAuthModalEmailField("");
    }
  }, [setAuthModalEmailField, setAuthModalValue, user]);

  const initializeAuth = useCallback(
    (email: string) => {
      setFlow(AuthFlows.EMAIL_LOGIN);
      setAuthModalEmailField(email);
      if (isMobile) {
        navigate(SCREENS.AUTH_SCREEN);
        setAuthRedirect(location.pathname);
      } else {
        setAuthModalValue(true);
      }
    },
    [
      setFlow,
      setAuthModalEmailField,
      isMobile,
      navigate,
      setAuthRedirect,
      location.pathname,
      setAuthModalValue,
    ],
  );

  const handleRedirect = useCallback(() => {
    if (authRedirectValue) {
      const path = `${authRedirectValue}`;
      setAuthModalEmailField("");
      setAuthRedirect(undefined);
      navigate(path);
    }
  }, [authRedirectValue, navigate, setAuthModalEmailField, setAuthRedirect]);

  return {
    initializeAuth,
    handleRedirect,
  };
};

export default useAuthHandler;
